import { Car, Visit, VisitTimeProposition } from '../../models';
import {
  APPEND_WORKSHOP_ONGOING_VISITS,
  GET_WORKSHOP_ONGOING_VISITS,
} from '../constants/visitsOngoingList';

/* eslint-disable camelcase */
const convertCar = (car, car_ownership, finished, image) => {
  return new Car(
    car.id,
    car.make_name,
    car.model_name,
    car.variant,
    car.version,
    car.vin,
    car.production_year,
    car.fuel,
    car.engine_capacity,
    car.engine_power_kw,
    car.curb_weight,
    car.first_registration_date,
    car_ownership.car_nickname,
    car_ownership.color,
    car_ownership.owner_id,
    car_ownership.registration_number,
    car_ownership.id,
    finished,
    image,
  );
};

export const getWorkshopOngoingVisits = (ownerId, response) => {
  const { count, limit, offset, next, previous, results: visits } = response ?? {};

  const convertedVisits = visits?.map((data) => {
    const {
      id,
      car_ownership,
      workshop_ownership,
      scheduled_time,
      message_from_client,
      message_from_workshop,
      status,
      time_preference,
      time_proposition,
      car,
      initiated_by,
      payment_status,
    } = data;

    const convertedCar = convertCar(car, car_ownership);

    const timePropositions = time_proposition
      ? new VisitTimeProposition(
          id,
          time_proposition.first_proposition,
          time_proposition.second_proposition,
        )
      : null;

    return new Visit(
      id,
      car_ownership,
      workshop_ownership,
      scheduled_time,
      message_from_client,
      message_from_workshop,
      status,
      time_preference,
      timePropositions,
      null,
      null,
      convertedCar,
      null,
      null,
      null,
      null,
      null,
      initiated_by,
      payment_status,
    );
  });
  return (dispatch) => {
    dispatch({
      type: GET_WORKSHOP_ONGOING_VISITS,
      ownerId,
      visits: convertedVisits,
      count,
      limit,
      offset,
      next,
      previous,
    });
  };
};

export const appendWorkshopOngoingVisits = (ownerId, response) => {
  const { count, limit, offset, next, previous, results: visits } = response ?? {};

  const convertedVisits = visits.map((data) => {
    const {
      id,
      car_ownership,
      workshop_ownership,
      scheduled_time,
      message_from_client,
      message_from_workshop,
      status,
      time_preference,
      time_proposition,
      car,
      initiated_by,
      payment_status,
    } = data;

    const convertedCar = convertCar(car, car_ownership);

    const timePropositions = time_proposition
      ? new VisitTimeProposition(
          id,
          time_proposition.first_proposition,
          time_proposition.second_proposition,
        )
      : null;

    return new Visit(
      id,
      car_ownership,
      workshop_ownership,
      scheduled_time,
      message_from_client,
      message_from_workshop,
      status,
      time_preference,
      timePropositions,
      null,
      null,
      convertedCar,
      null,
      null,
      null,
      null,
      null,
      initiated_by,
      payment_status,
    );
  });
  return (dispatch) => {
    dispatch({
      type: APPEND_WORKSHOP_ONGOING_VISITS,
      ownerId,
      visits: convertedVisits,
      count,
      limit,
      offset,
      next,
      previous,
    });
  };
};
